import { api } from "../lib";

export const SELECTED_TASKS_PREFERENCE_KEY = "selected_tasks";

export const userPreferencesService = {
  saveSelectedTasks: async (taskIds: string[]): Promise<void> => {
    await api.put(`/users/me/preferences/${SELECTED_TASKS_PREFERENCE_KEY}`, {
      value: { taskIds },
    });
  },
};
